/**
 * @param {string} url
 * @return {string}
*/
const shortenUrl = (url) => {
    const split = url.split('//');

    const urlWithoutHttps = split[1];

    if (!urlWithoutHttps) {
        return '';
    }

    const urlHttps = split[0] + '//';
    const firstPartOfUrl = urlWithoutHttps.split('/')[0];

    if (!firstPartOfUrl) {
        return '';
    }

    return urlHttps + firstPartOfUrl + '/';
};

export default shortenUrl;
